"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function DisconnectIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("rect", { x: "11.15", y: "2.275", width: "1.7", height: "19.45", transform: "translate(-4.971 12) rotate(-45)" }),
        react_1.default.createElement("path", { d: "m13.515,17.545l-1.703,1.703c-1.946,1.946-5.114,1.946-7.06,0-1.946-1.946-1.946-5.113,0-7.059l1.703-1.703-1.202-1.202-1.703,1.703c-2.609,2.609-2.609,6.855,0,9.464,2.609,2.609,6.855,2.609,9.464,0l1.703-1.703-1.202-1.202Z" }),
        react_1.default.createElement("path", { d: "m10.486,6.455l1.703-1.703c1.947-1.947,5.113-1.947,7.06,0s1.947,5.114,0,7.06l-1.703,1.703,1.202,1.202,1.703-1.703c2.609-2.609,2.609-6.854,0-9.463-2.609-2.609-6.855-2.609-9.463,0l-1.703,1.703,1.202,1.202Z" })));
}
exports.default = DisconnectIcon;
